export * from './MainLogo';